import { supabase } from "../supabaseClient";

/**
 * Fetch user details by user IDs using the Edge Function
 * @param {string[]} userIds - Array of user IDs to fetch
 * @returns {Promise<{data: any[], error: any}>}
 */
export const fetchUsersByIds = async (userIds) => {
  try {
    const { data, error } = await supabase.functions.invoke(
      "get-users-by-ids",
      {
        body: { user_ids: userIds },
      }
    );

    if (error) {
      throw error;
    }

    return { data: data.data, error: null };
  } catch (error) {
    console.error("Error fetching users by IDs:", error);
    return { data: [], error };
  }
};
